// Generated by purs version 0.14.4
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Unscramble from "../Unscramble/index.js";
var genericSumDecoder = function (dict) {
    return dict.genericSumDecoder;
};
var genericDecoder = function (dict) {
    return dict.genericDecoder;
};
var genericUnsafeDecode = function (dictGeneric) {
    return function (dictGenericDecode) {
        return function (opts) {
            var $42 = Data_Generic_Rep.to(dictGeneric);
            var $43 = genericDecoder(dictGenericDecode)(opts);
            return function ($44) {
                return $42($43($44));
            };
        };
    };
};
var genericDecodeTaggedSumType = function (dictGenericDecodeSum) {
    return function (opts) {
        var constructors = Foreign_Object.fromFoldable(Data_Foldable.foldableArray)(genericSumDecoder(dictGenericDecodeSum)(opts));
        return function (value) {
            var tag = Unscramble.decodeString(value.tag);
            var v = Foreign_Object.lookup(tag)(constructors);
            if (v instanceof Data_Maybe.Nothing) {
                return Unscramble.decodingError("Invalid sum type tag: " + Data_Show.show(Data_Show.showString)(tag));
            };
            if (v instanceof Data_Maybe.Just) {
                return v.value0(value);
            };
            throw new Error("Failed pattern match at Unscramble.Generic (line 49, column 5 - line 53, column 22): " + [ v.constructor.name ]);
        };
    };
};
var genericUnsafeDecodeTagged = function (dictGeneric) {
    return function (dictGenericDecodeSum) {
        return function (opts) {
            var $45 = Data_Generic_Rep.to(dictGeneric);
            var $46 = genericDecodeTaggedSumType(dictGenericDecodeSum)(opts);
            return function ($47) {
                return $45($46($47));
            };
        };
    };
};
var genericDecodeSumType = function (dictGenericDecodeSum) {
    return {
        genericDecoder: genericDecodeTaggedSumType(dictGenericDecodeSum)
    };
};
var genericDecodeSum = function (dictGenericDecodeSum) {
    return function (dictGenericDecodeSum1) {
        return {
            genericSumDecoder: function (opts) {
                return Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Tuple.functorTuple)(Data_Functor.map(Data_Functor.functorFn)(Data_Generic_Rep.Inl.create)))(genericSumDecoder(dictGenericDecodeSum)(opts)))(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Tuple.functorTuple)(Data_Functor.map(Data_Functor.functorFn)(Data_Generic_Rep.Inr.create)))(genericSumDecoder(dictGenericDecodeSum1)(opts)));
            }
        };
    };
};
var genericDecodeSingleRecordArgumentConstructor = function (dictRowToList) {
    return function (dictDecodeRecord) {
        return function (dictIsSymbol) {
            return {
                genericSumDecoder: function (opts) {
                    return [ new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value), (function () {
                        var $48 = Unscramble.unsafeDecode(Unscramble.decode_Record()(dictDecodeRecord));
                        return function ($49) {
                            return Data_Generic_Rep.Constructor(Data_Generic_Rep.Argument($48($49)));
                        };
                    })()) ];
                }
            };
        };
    };
};
var genericDecodeManyArgsArgument = function (dictDecode) {
    return {
        argsDecoder: new Data_Tuple.Tuple(1, function (offset) {
            return function (array) {
                return Unscramble.unsafeDecode(dictDecode)(array[offset]);
            };
        })
    };
};
var genericDecodeArgsSingleArg = function (dictDecode) {
    return {
        genericDecodeArgs: (function () {
            var $50 = Unscramble.unsafeDecode(dictDecode);
            return function ($51) {
                return Data_Generic_Rep.Argument($50($51));
            };
        })()
    };
};
var genericDecodeArgsNoArguments = {
    genericDecodeArgs: function (v) {
        return Data_Generic_Rep.NoArguments.value;
    }
};
var genericDecodeArgs = function (dict) {
    return dict.genericDecodeArgs;
};
var genericDecodeConstructor = function (dictGenericDecodeArgs) {
    return function (dictIsSymbol) {
        return {
            genericSumDecoder: function (opts) {
                return [ new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value), (function () {
                    var $52 = genericDecodeArgs(dictGenericDecodeArgs);
                    return function ($53) {
                        return Data_Generic_Rep.Constructor($52((function (v) {
                            return v.contents;
                        })($53)));
                    };
                })()) ];
            }
        };
    };
};
var genericDecodeSingleConstructor = function (dictGenericDecodeArgs) {
    return {
        genericDecoder: function (opts) {
            var $54 = genericDecodeArgs(dictGenericDecodeArgs);
            return function ($55) {
                return Data_Generic_Rep.Constructor($54($55));
            };
        }
    };
};
var defaultOptions = {};
var argsDecoder = function (dict) {
    return dict.argsDecoder;
};
var genericDecodeArgsManyArgs = function (dictGenericDecodeManyArgs) {
    return {
        genericDecodeArgs: (function () {
            var v = argsDecoder(dictGenericDecodeManyArgs);
            return function (value) {
                var array = Unscramble.expectArray(value);
                var $33 = Data_Array.length(array) === v.value0;
                if ($33) {
                    return v.value1(0)(array);
                };
                return Unscramble.decodingError("Invalid number of constructor arguments");
            };
        })()
    };
};
var genericDecodeManyArgsProduct = function (dictGenericDecodeManyArgs) {
    return function (dictGenericDecodeManyArgs1) {
        return {
            argsDecoder: (function () {
                var v = argsDecoder(dictGenericDecodeManyArgs);
                var v1 = argsDecoder(dictGenericDecodeManyArgs1);
                return new Data_Tuple.Tuple(v.value0 + v1.value0 | 0, function (offset) {
                    return function (array) {
                        return new Data_Generic_Rep.Product(v.value1(offset)(array), v1.value1(offset + v.value0 | 0)(array));
                    };
                });
            })()
        };
    };
};
export {
    argsDecoder,
    genericDecodeArgs,
    genericDecoder,
    genericSumDecoder,
    genericUnsafeDecode,
    genericUnsafeDecodeTagged,
    defaultOptions,
    genericDecodeTaggedSumType,
    genericDecodeSingleConstructor,
    genericDecodeSumType,
    genericDecodeSingleRecordArgumentConstructor,
    genericDecodeConstructor,
    genericDecodeArgsNoArguments,
    genericDecodeArgsSingleArg,
    genericDecodeArgsManyArgs,
    genericDecodeManyArgsProduct,
    genericDecodeManyArgsArgument,
    genericDecodeSum
};
//# sourceMappingURL=index.js.map
